import {useEffect} from 'react';
import {UiLongTask} from 'types/long-task';

import {UseUILongTaskReturnType} from './useLongTask';

type UseLongTaskFinishedFunction = (
    methods: UseUILongTaskReturnType,
    callbacks: {
        onError: (LongTask: UiLongTask) => void;
        onSuccess: (LongTask: UiLongTask) => void;
    },
) => void;

/**
 * Responsibility:
 * - If LongTask is finished and has no errors, call onSuccess
 * - If LongTask is finished and has errors, call onError
 */
const useLongTaskFinished: UseLongTaskFinishedFunction = (
    methods,
    {onError, onSuccess},
) => {
    useEffect(() => {
        if (methods.longTask?.finished) {
            if (methods.longTask.errors.length) {
                onError(methods.longTask);
            } else {
                onSuccess(methods.longTask);
            }
        }
    }, [methods.longTask, onError, onSuccess]);
};
export default useLongTaskFinished;
